module.exports = __webpack_public_path__ + "static/media/lt.576fbe90.webp";